import React from "react";
import {
  Box,
  Stack,
  SvgIcon,
  Typography,
  styled,
  useTheme,
} from "@mui/material";
import { ReactComponent as BuyIcon } from "@/assets/icons/Buy.svg";
import { ReactComponent as SellIcon } from "@/assets/icons/Sell.svg";

const Button = styled(Box)(({ theme }) => ({
  width: "142px",
  height: "fit-content",
  paddingTop: "0",
  paddingBottom: "17.65px",
  position: "relative",
  borderRadius: `${theme.borderRadius.main} ${theme.borderRadius.main} 0 0`,
  "&::before": {
    content: "''",
    position: "absolute",
    bottom: "0",
    left: "0",
    height: "4px",
    borderRadius: "2px",
    backgroundColor: theme.colors.blueDark,
    transition: "all 0.25s ease-out",
  },
  "&:hover": {
    background: "none",
    cursor: "pointer",
    "&::before": {
      width: "100%",
    },
  },
}));

interface IProps {
  side: string;
  setSide: (side: "sell" | "buy") => void;
}
const TradeNav = ({ side, setSide }: IProps) => {
  const theme = useTheme();
  const isSellPage = side === "sell";
  const isBuyPage = side === "buy";

  return (
    <Stack direction="row" gap="42px" mt="16.5px">
      <Button
        onClick={() => setSide("buy")}
        sx={{
          "&::before": {
            width: isBuyPage ? "100%" : "0%",
          },
        }}
      >
        <SvgIcon
          component={BuyIcon}
          inheritViewBox
          sx={{
            width: "24px",
            height: "24px",
            mr: "21px",
            filter: isBuyPage
              ? theme.filters.blueDark
              : theme.filters.unFocused,
            transition: "all 0.25s ease-out",
            fill: "none",
          }}
        />
        <Typography
          variant="h3"
          color={isBuyPage ? theme.colors.blueDark : theme.colors.unFocused}
          display="inline"
        >
          Buy
        </Typography>
      </Button>
      <Button
        onClick={() => setSide("sell")}
        sx={{
          "&::before": {
            width: isSellPage ? "100%" : "0%",
          },
        }}
      >
        <SvgIcon
          component={SellIcon}
          inheritViewBox
          sx={{
            width: "24px",
            height: "24px",
            mr: "21px",
            filter: isSellPage
              ? theme.filters.blueDark
              : theme.filters.unFocused,
            transition: "all 0.25s ease-out",
            fill: "none",
          }}
        />
        <Typography
          variant="h3"
          color={isSellPage ? theme.colors.blueDark : theme.colors.unFocused}
          sx={{ transition: "all 0.25s ease-out" }}
          display="inline"
        >
          Sell
        </Typography>
      </Button>
    </Stack>
  );
};

export default TradeNav;
